import React, { useState, useEffect } from "react";

import { Modal, Button, Header, Input, Divider, Form } from "semantic-ui-react";
import "./OperatorInputModal.css";
import NumPad from "../NumPad/NumPad";
import * as Constants from "../../utils/Constants";
import SharedFunctions from "../../utils/SharedFunctions";
import { OPERATOR_INPUT_MODAL } from "../../utils/constants/componentConstants";

const { KeyPadKeyCode } = Constants;

const OperatorInputModal = ({
  open,
  onClose,
  submitCallback,
  headerText,
  submitButtonText,
  isScanIdValidationRequired,
}) => {
  const [operatorID, setOperatorID] = useState("");
  const [shownValue, setShownValue] = useState("");
  const [password, setPassword] = useState(-1);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    function onOpen() {
      SharedFunctions.LogPopupShownEvent(OPERATOR_INPUT_MODAL);
    }
    if (open) {
      onOpen();
    }
    // return () => {
    //   clearState();
    //   handleInputError();
    // };
  }, [open]);

  const numberChange = (value, target) => {
    if (value) {
      let parsedValue = parseInt(value);
      if (parsedValue && parsedValue > 0) {
        value = parsedValue;
      } else {
        value = "";
      }
    }
    target(value + "");
  };

  const setShownValueAndPlaceholderValue = (val) => {
    setShownValue([...val].map((x) => "•").join(""));
    setOperatorID(val);
  };

  const clearState = () => {
    setOperatorID("");
    setPassword(-1);
    setError("");
    setLoading(false);
  };

  const handleInputError = (e) => {
    setLoading(false);
    setError(e.message);
    setShownValueAndPlaceholderValue("");
  };

  const onCloseClearState = () => {
    clearState();
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const onKeyPadInput = (key) => {
    if (key === KeyPadKeyCode.BACKSPACE) {
      let operatorIDString = operatorID.toString();
      numberChange(
        operatorIDString.substr(0, operatorIDString.length - 1),
        setShownValueAndPlaceholderValue
      );
    } else if ((key || key === KeyPadKeyCode.ZERO) && key !== KeyPadKeyCode.BACKSPACE) {
      numberChange(operatorID + key, setShownValueAndPlaceholderValue);
    }
  };

  function keyboardInputActions(e) {
    let key = e.keyCode;
    if (key === 8) {
      onKeyPadInput(KeyPadKeyCode.BACKSPACE);
    }
    if (key === 13) {
      submitCallbackAndCleanup();
    }
  }

  function keyboardInput(e) {
    const targetValue = e.target.value;
    const value = targetValue.replace(/[^0-9.]/g, "");

    if (value.length) {
      onKeyPadInput(value);
    }
  }

  function submitCallbackAndCleanup() {
    if (operatorID?.length === 0) return;
    setLoading(true);
    submitCallback(operatorID, clearState, handleInputError);
  }

  const getOperatorConfirmInputText = () => {
    return isScanIdValidationRequired
      ? "En ansvarig behöver scanna sin bricka"
      : "Ange ansvarigs operatörsnummer:";
  };

  const getOperatorConfirmInputPlaceholder = () => {
    return isScanIdValidationRequired ? "Scanna bricka" : "Operatörsnummer";
  };

  return (
    <Modal
      open={open}
      size="small"
      className={"OperatorInputModal"}
      closeOnDimmerClick={false}
      closeOnEscape={false}
    >
      <Header icon="warning sign" color="red" content={headerText} />
      <Modal.Content>
        <div className="operator-name-info">{getOperatorConfirmInputText()}</div>
        <div className="error-message" style={{ display: error ? "inline-block" : "none" }}>
          {error}
        </div>
        <Form.Input
          id="OperatorInput"
          fluid
          size="massive"
          placeholder={getOperatorConfirmInputPlaceholder()}
          autoFocus
          autoComplete="off"
          onChange={(e) => keyboardInput(e)}
          onKeyDown={(e) => keyboardInputActions(e)}
          value={shownValue ? shownValue : ""}
        />
        <Divider style={{ display: "none" }} />
        <Input
          placeholder="Lösenord"
          type="password"
          value={password >= 0 ? password : ""}
          style={{ display: "none" }}
          autoComplete="new-password"
          disabled
        />
        <NumPad onClick={(val) => onKeyPadInput(val)} />
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={onCloseClearState} floated={"left"}>
          AVBRYT
        </Button>
        <Button color="red" onClick={submitCallbackAndCleanup} loading={loading}>
          {submitButtonText}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default OperatorInputModal;
